var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.5C2.05 0.5 2.5 0.95 2.5 1.5V14.5C2.5 15.05 2.95 15.5 3.5 15.5H20.5C21.05 15.5 21.5 15.95 21.5 16.5C21.5 17.05 21.05 17.5 20.5 17.5H3.5C1.84 17.5 0.5 16.16 0.5 14.5V1.5C0.5 0.95 0.95 0.5 1.5 0.5Z",
    fill: "#6D5EF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5C5.45 8.5 5 8.95 5 9.5V12.5C5 13.05 5.45 13.5 6 13.5C6.55 13.5 7 13.05 7 12.5V9.5C7 8.95 6.55 8.5 6 8.5Z",
    fill: "#6D5EF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.5C9.95 5.5 9.5 5.95 9.5 6.5V12.5C9.5 13.05 9.95 13.5 10.5 13.5C11.05 13.5 11.5 13.05 11.5 12.5V6.5C11.5 5.95 11.05 5.5 10.5 5.5Z",
    fill: "#6D5EF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7C14.45 7 14 7.45 14 8V12.5C14 13.05 14.45 13.5 15 13.5C15.55 13.5 16 13.05 16 12.5V8C16 7.45 15.55 7 15 7Z",
    fill: "#6D5EF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.5C18.95 3.5 18.5 3.95 18.5 4.5V12.5C18.5 13.05 18.95 13.5 19.5 13.5C20.05 13.5 20.5 13.05 20.5 12.5V4.5C20.5 3.95 20.05 3.5 19.5 3.5Z",
    fill: "#6D5EF6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphBlock);
export default __webpack_public_path__ + "static/media/GraphBlock.5aa48b46f15da8336a877b5c91365b45.svg";
export { ForwardRef as ReactComponent };